
        var result = require("!!../../../node_modules/css-loader/index.js!./tos.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/tos/tos.component.css
// module id = 456
// module chunks = 2